/* eslint-disable */
export default {
  data () {
    return {
      notificationsSupported: false,
      serviceWorkerRegistation: null,
      notificationLoading: false,
      subscription: null
    }
  },
  created () {
    // Armazenamos se o usuário habilitou notificações ou não no localStorage. Iniciamos esse valor com "false"
    localStorage.setItem('notificationsEnabled', false)
    if ('Notification' in window && 'serviceWorker' in navigator) {
      this.notificationsSupported = true
    }
    this.findSubscription().then(sub => {
      if (sub !== null) {
        this.subscription = sub
      }
    })
  },
  methods: {
    enableSubscription () {
      if (this.notificationsSupported) {
        this.notificationLoading = true
        if (localStorage.getItem('notificationsEnabled') !== 'true') {
          Notification.requestPermission().then((result) => {
            // if granted, create new subscription
              if (result === 'granted') {
                this.createSubscription().then((sub) => {
                  this.subscription = sub
                  const user = this.$auth.user()
                  // store new subscription on the server
                  return this.$http.post(`api/subscription`, { subscription: sub, userId: user.id, oldEndpoint: localStorage.getItem('notificationEndpoint') }).then(() => {
                    this.afterEnableSubscription()
                    localStorage.setItem('notificationsEnabled', true)
                    localStorage.setItem('notificationEndpoint', sub.endpoint)
                    this.notificationLoading = false
                  })
                })
              } else {
                this.notificationLoading = false
                console.log('User did not granted permission.')
              }
            })
        } else {
          this.notificationLoading = false
          console.log('Notifications already enabled.')
        }
      } else {
        this.notificationLoading = false
        console.log('Notifications sot suported.')
      }
    },
    disableSubscription () {
      this.notificationLoading = true
      if (this.subscription !== null) {
        // destroy on the server
        return this.$http.post(`api/subscription/delete`, {
          endpoint: this.subscription.endpoint
        }).then(() => this.subscription.unsubscribe()).then(() => {
          // unsubscribe on the client
          this.afterDisableSubscription()
          localStorage.setItem('notificationsEnabled', false)
          this.subscription = null
          this.notificationLoading = false
          console.log('Done')
        })
      } else {
        this.notificationLoading = false
        console.log('Subscription not found')
      }
    },
    createSubscription () {
      if (this.serviceWorkerRegistation === null) {
        return navigator.serviceWorker.ready // returns a Promise, the active SW registration
          .then(swreg => {
            this.serviceWorkerRegistation = swreg
            return this.subscribe(this.serviceWorkerRegistation)
          })
      } else {
        return this.subscribe(this.serviceWorkerRegistation)
      }
    },
    getSubscription (swreg) {
      return swreg.pushManager.getSubscription()
    },
    subscribe (swreg) {
      // create new subscription for this browser on this device
      const vapidPublicKey = 'BOBgz176trxs1I+qWP7WqXQUdRAQr4Khalo8tOSMCI75+VgyRTmpR32KFJhkmt4r4AZ5osbdBXS+1pxHKAvW21M='
      const convertedVapidPublicKey = this.urlBase64ToUint8Array(vapidPublicKey)
      // return the subscription promise, we chain another then where we can send it to the server
      return swreg.pushManager.subscribe({
        userVisibleOnly: true,
        // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
        // that you can find in .env to make this work in the end
        applicationServerKey: convertedVapidPublicKey
      })
    },
    findSubscription () {
      return navigator.serviceWorker.ready.then(swreg => {
        this.serviceWorkerRegistation = swreg
        return this.getSubscription(this.serviceWorkerRegistation)
      })
    },
    urlBase64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/')
      const rawData = window.atob(base64)
      let outputArray = new Uint8Array(rawData.length)
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    },
    checkNotificationSupported() {
      // Verificação para mostrar ou não o botão toggle no Card Notificações
      // Se o browser suportar notificações retorna true.
      if ('Notification' in window && 'serviceWorker' in navigator) {
        return true
      } else {
        return false
      }
    },
    afterDisableSubscription () {},
    afterEnableSubscription () {}
  }
}



// WEBPACK FOOTER //
// ./src/mixin/notification.js